import { render, staticRenderFns } from "./FlowComponent.vue?vue&type=template&id=271c9e4a"
import script from "./FlowComponent.vue?vue&type=script&lang=js"
export * from "./FlowComponent.vue?vue&type=script&lang=js"
import style0 from "./FlowComponent.vue?vue&type=style&index=0&id=271c9e4a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports